import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';
import { injectIntl } from 'react-intl';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import { sendDataLayerEvent } from '../../utils/analytics';
import { getRelativePath } from '../../utils/url';
import {map, partial} from 'lodash';

const handleContributorClick = (name: string, path: string): void => {
  sendDataLayerEvent('Click', {
    linkType: 'breadcrumb',
    linkTitle: name,
    linkURL: path,
    pageModule: 'Byline'
  });
};

const FeaturedBylineText = ({ byline, name }) => (
  <RosettaFormattedMessage parentFilename={__filename}
    id="byline"
    key={byline + name}
    description="Featured contributor in the footer"
    defaultMessage="{byline} by {name}"
    values={{
      byline,
      name: (
        <span className="featured-name"
          dangerouslySetInnerHTML={{ __html: name }}
        />
      )
    }}
  />
);

FeaturedBylineText.propTypes = {
  name: PropTypes.string.isRequired,
  byline: PropTypes.string.isRequired
};

const FeaturedContributors = ({ bylines }, { edition_data }) => (
  <div className="byline featured-contributors">
    {
      map(bylines, ({ byline, name, path }) => (
        <div key={byline + name} className="featured-byline">
          <Link
            to={getRelativePath(path, edition_data)}
            onClick={partial(handleContributorClick, name, path)}
            target="_blank"
          >
            <FeaturedBylineText
              byline={byline}
              name={name}
            />
          </Link>
        </div>
      ))
    }
  </div>);

FeaturedContributors.propTypes = {
  bylines: PropTypes.arrayOf(
    PropTypes.shape({
      ...FeaturedBylineText.propTypes
    }).isRequired
  ).isRequired
};

FeaturedContributors.contextTypes = {
  edition_data: PropTypes.object
};

export default injectIntl(FeaturedContributors);
